import { ContactDetails } from '@futrli-sdk/predict';
import { Data } from '../../../../utils/table-filters/filter-table-types';
export interface State {
  isOpenSidePanel: boolean;
  isLoading: boolean;
  isLoadingDetails: boolean;
  activeCustomerSupplier?: ContactDetails;
  periodValue?: string;
  data?: Data[];
}

export enum ActionTypes {
  SET_DATA = 'SET_DATA',
  SET_IS_LOADING = 'SET_IS_LOADING',
  SET_PERIOD_VALUE = 'SET_PERIOD_VALUE',
  SET_ACTIVE_CUSTOMER_SUPPLIER = 'SET_ACTIVE_CUSTOMER_SUPPLIER',
  SET_IS_OPEN_SIDE_PANEL = 'SET_IS_OPEN_SIDE_PANEL',
  SET_IS_LOADING_DETAILS = 'SET_IS_LOADING_DETAILS'
}

export interface ActionPayload {
  [ActionTypes.SET_PERIOD_VALUE]: {
    periodValue?: string;
  };
  [ActionTypes.SET_DATA]: {
    data: Data[];
  };
  [ActionTypes.SET_ACTIVE_CUSTOMER_SUPPLIER]: {
    activeCustomerSupplier?: ContactDetails;
  };
  [ActionTypes.SET_IS_OPEN_SIDE_PANEL]: {
    isOpenSidePanel: boolean;
  };
  [ActionTypes.SET_IS_LOADING]: {
    isLoading: boolean;
  };
  [ActionTypes.SET_IS_LOADING_DETAILS]: {
    isLoadingDetails: boolean;
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export type Action = ActionMap<ActionPayload>[keyof ActionMap<ActionPayload>];
